import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  // firmasList:[],
  currentOrden: JSON.parse(localStorage.getItem("currentOrden")) || ''
};
export const mutations = {
  SHOW_AMPARO ({ context }, amparo) {
    state.currentOrden = Object.assign({}, amparo);
    localStorage.setItem("currentOrden", JSON.stringify(state.currentOrden));
  }
};
export const actions = {

  CREATE_AMPARO({ commit }, data) {
    // console.log(data);
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        ApiService.post(data)
          .then(response => {
            commit("SET_LOADING", false);
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_AMPAROS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_AMPAROS", response.data.data.amparos);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SHOW_AMPARO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("SHOW_AMPARO", response.data.data.amparo);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

};

export const getters = {
  // firmasList: state => state.firmasList
};
